import uuid from "react-uuid";

import { FertilizerApplication, FertilizerType } from "models";

export const BLANK_FERTILIZER_APPLICATION = (fertilizerType: FertilizerType) =>
  ({
    id: uuid(),
    endDate: "",
    cropId: "",
    type: `${fertilizerType}Fertilizers`,
    assignedPracticeId: "",
    applicationType: "",
    amount: 0.01,
    nValue: 0,
    selfProduced: null,
    payout: 0,
  }) as FertilizerApplication;
